import { render, staticRenderFns } from "./RegistrationGuide.vue?vue&type=template&id=7f9aae48&scoped=true"
import script from "./RegistrationGuide.vue?vue&type=script&lang=js"
export * from "./RegistrationGuide.vue?vue&type=script&lang=js"
import style0 from "./RegistrationGuide.vue?vue&type=style&index=0&id=7f9aae48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9aae48",
  null
  
)

export default component.exports